import apiConfig from '../../../apiConfig';

export type StaffOptionForDate = {
  staff_id: number;
  name: string;
  nickname: string | null;
  icon_url: string | null;
  bio?: string | null;
  role_name?: string | null;
  sns_links?: Array<{
    platform: string;
    url: string;
  }>;
};

export type FetchStaffOptionsForDateResponse = {
  staffs: StaffOptionForDate[];
  free_available: boolean;
};

export const fetchStaffOptionsForDate = async (params: {
  storeId: number;
  date: string;
  startTime: string;
  serviceIds: number[];
}): Promise<FetchStaffOptionsForDateResponse> => {
  const url = new URL(`${apiConfig.baseURL}/api/customer-app/reservation/by-date/staff-options`);
  url.searchParams.set('store_id', String(params.storeId));
  url.searchParams.set('date', params.date);
  url.searchParams.set('start_time', params.startTime);
  url.searchParams.set('service_ids', params.serviceIds.join(','));

  const res = await fetch(url.toString(), { method: 'GET' });
  if (!res.ok) {
    const data = await res.json().catch(() => ({}));
    throw new Error((data as any).error || 'Failed to fetch staff options');
  }

  const data = (await res.json()) as FetchStaffOptionsForDateResponse;
  return {
    staffs: Array.isArray(data.staffs) ? data.staffs : [],
    free_available: Boolean(data.free_available),
  };
};
